import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

/**
 * Provider to help parse files and return the contents as usable data objects
 */
@Injectable()
export class FileManagerProvider {

  constructor(private http: HttpClient) {
  }

  /**
   * Gets data with a promise which will return with the data when the task is complete
   * Uses generic type T to define schema interface to ensure returning json matches schema template.
   */
  public getJSONDataAsync(filePath: string): Promise<any> {
    const headers = new HttpHeaders({
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains"
    });
    const httpOptions = { headers };
    return this.http.get(filePath, httpOptions).toPromise();
  }

  public getHTMLDataAsync(filePath: string): Promise<any> {
    const headers = new HttpHeaders({
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains"
    })
    return this.http.get(filePath, { headers: headers , responseType: 'text' }).toPromise();
  }
}
